import React from 'react';
import styled from 'styled-components/macro';
import { ILandingPageBuilderForm } from '../../../types';
import { Flex } from 'lib/components/styles/layout';
import { LP_DESIGN_SOCIAL_MEDIA } from '../../../constants';
import { SocialIcon } from '../../../helpers/socialIcons';
import { getFooterLogo, SOCIAL_ICONS } from '../constants';

export const FooterContainer = styled.div<{
  values: ILandingPageBuilderForm;
  isMobile: boolean;
  footerBackgroundColor: string;
  showFooterShadow: number;
  screenshot: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 101px;
  box-sizing: border-box;
  padding: 24px 18px;
  background: ${({ footerBackgroundColor }) =>
    footerBackgroundColor
      ? footerBackgroundColor
      : props => props.theme.colors.neutral[40]};

  border-top: ${({ screenshot, showFooterShadow, theme }) =>
    screenshot && showFooterShadow && `3px solid ${theme.colors.neutral[10]}`};

  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 6px;
    pointer-events: none;
    background: transparent;
    box-shadow: ${({ showFooterShadow }) =>
      showFooterShadow ? '0 -2px 4px -1px rgba(0, 0, 0, 0.12)' : 'none'};
  }
`;

interface IFooterProps {
  values: ILandingPageBuilderForm;
  isMobile: boolean;
  screenshot?: boolean;
}

export const Footer = ({
  values,
  isMobile,
  screenshot = false,
}: IFooterProps) => {
  const {
    footerBackgroundColor,
    socialMediaIconType,
    footerLogo,
    showSocialMediaIcons,
    showFooterShadow,
  } = values;

  const LOGO_TYPE = getFooterLogo();
  return (
    <FooterContainer
      values={values}
      isMobile={isMobile}
      footerBackgroundColor={footerBackgroundColor}
      showFooterShadow={showFooterShadow}
      screenshot={screenshot}
    >
      <Flex gap='16px' alignItems='center' justifyContent='center'>
        {!!showSocialMediaIcons && (
          <Flex
            flexDirection='row'
            gap='4px'
            justifyContent='center'
            flexWrap='wrap'
            style={{ boxSizing: 'border-box' }}
          >
            {SOCIAL_ICONS.map((icon, idx) => (
              <SocialIcon
                key={idx}
                size={25}
                svgSize={16}
                icon={icon}
                design={
                  socialMediaIconType ?? LP_DESIGN_SOCIAL_MEDIA.WHITE_SQUARE
                }
              />
            ))}
          </Flex>
        )}
        {footerLogo !== null && LOGO_TYPE[footerLogo]}
      </Flex>
    </FooterContainer>
  );
};
